import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useFetcher } from "react-router-dom";

const useStyles = makeStyles({
    inputWrapper: {
        position: "relative",
        display: "inline-flex",
        alignItems: "center"
    },
    editableInput: {
        width: "70px",
        textAlign: "center",
        border: "0.5px solid #0082CA",
        borderRadius: "4px",
        padding: "2px 5px",
        color: "#929497",
        '&::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
          '&::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
          '&[type="number"]': {
            MozAppearance: 'textfield', // For Firefox
            MsAppearance: 'textfield',  // For IE/Edge
          },
    },

    percentageSign: {
        position: "absolute",
        right: "5px",
        top: "50%",
        transform: "translateY(-50%)",
        pointereEvents: "none", /* Prevents the percentage sign from interfering with input focus */
        fontSize: "16px",
        color: "#929497",
      },
});


const ThresholdInputBox = ({
    _index,
    row,
    _graphData, 
    entityAndThreshold, 
    setEntityAndThreshold,
}) => {
    const classes = useStyles();
    const [thresholdValue, setThresholdVal] = useState(null);

    const handleThresholdChange = (value) => {
        setThresholdVal(value);
        let currentEntityName = row?.Entity_name;
        let allEditedEntityNames = entityAndThreshold?.map(data => data?.Entity);
        if(allEditedEntityNames?.includes(currentEntityName)){
            let objIndex = entityAndThreshold?.findIndex(item => item?.Entity === currentEntityName);
            let tempEntity = [...entityAndThreshold];
            tempEntity[objIndex].Threshold = Number(value);
            setEntityAndThreshold([...tempEntity]);
        }else{
            let tempObj = {
                Entity: currentEntityName,
                Threshold: Number(value)
            };
            let thresholdArray = [...entityAndThreshold, tempObj];
            setEntityAndThreshold([...thresholdArray]);
        }
    };

    useEffect(()=>{
        setThresholdVal(row?.Threshold);
    }, []);

    return(
        <div className={classes.inputWrapper}>
            <input
                type="number"
                value={thresholdValue}
                className={classes.editableInput}
                onChange={(e) =>
                    handleThresholdChange(e.target.value)
                }
            />
            <span className={classes.percentageSign}>%</span>
        </div>
    );
};

export default ThresholdInputBox;
